<template>
  <v-container>
    <vue-simple-calendar
      v-show="!dayViewProps.viewingDay"
      :show-date="showDate"
      @show-date-change="setShowDate"
      class="theme-default"
      :events="displayPeriodUom === 'month' ? groupedEvents : events"
      :displayPeriodUom="displayPeriodUom"
      eventContentHeight="2em"
      @click-date="selectDate"
      @click-event="selectEvent">
      <v-layout wrap slot="header" class="cv-header">
        <v-flex xs12 sm6 md4 lg3 class="cv-header-nav">
          <v-btn class="previousYear navButton" color="primary" icon @click="previousYear"><v-icon>first_page</v-icon></v-btn>
          <v-btn class="previousPeriod navButton" color="primary" icon @click="previousPeriod"><v-icon>chevron_left</v-icon></v-btn>
          <v-btn class="nextPeriod navButton" color="primary" icon @click="nextPeriod"><v-icon>chevron_right</v-icon></v-btn>
          <v-btn class="nextYear navButton" color="primary" icon @click="nextYear"><v-icon>last_page</v-icon></v-btn>
          <v-btn class="currentPeriod navButton" color="primary" icon @click="today"><v-icon>today</v-icon></v-btn>
        </v-flex>
        <v-flex xs12 sm6 md4 lg7 class="periodLabel">{{dateLabel}}</v-flex>
        <v-flex xs12 sm4 offset-sm8 md4 offset-md0 lg2 text-xs-right>
          <v-btn
            flat
            icon
            @click="displayPeriodUom = 'week'"
            :color="displayPeriodUom === 'week' ? 'primary' : 'grey lighten-1'">            
            <v-icon>view_column</v-icon>
          </v-btn>
          <v-btn
            icon
            flat
            @click="displayPeriodUom = 'month'"
            :color="displayPeriodUom === 'month' ? 'primary' : 'grey lighten-1'">
            <v-icon>view_module</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-progress-linear
            :indeterminate="gettingEvents ? true : false" 
            :color="gettingEvents ? 'primary' : 'secondary'"  
            height="2" 
            :value="gettingEvents ? '' : 0" 
            style="margin:5px 0px 0px 0px;"></v-progress-linear>
        </v-flex>
      </v-layout>
    </vue-simple-calendar>
    <calendar-day-view
      v-show="dayViewProps.viewingDay"
      v-bind.sync="dayViewProps" :templates="templates" :engineers="engineers" :customers="customers"></calendar-day-view>
  </v-container>
</template>

<script>
import {fireStore} from '../firebase'
import moment from 'moment'
export default {
  props: ['Supplier'],
  data () {
    return {
      showDate: new Date(),
      dateLabel: null,
      events: [],
      engineers: [],
      activeEngineers: [],
      filterMenu: false,
      displayPeriodUom: 'month',
      periodStart: null,
      periodEnd: null,
      gettingEvents: false,
      dayViewProps: {
        Day: null,
        Supplier: this.Supplier,
        viewingDay: false
      }
    }
  },
  created () {
    this.$store.dispatch('fetchDeviceTypes')
    this.$store.dispatch('fetchCustomers')
    if (this.Supplier) {
      fireStore.collection('Users').where('Role', 'in', ['Engineer', 'Supplier', 'Support and Engineer', 'Admin and Engineer']).where('Company', '==', this.Supplier).get()
      .then(snap => {
        snap.forEach(doc => {
          this.engineers.push({name: doc.data().Name, key: doc.id})
          this.activeEngineers.push(doc.data().id)
        })
      })
    } else {
      fireStore.collection('Users').where('Role', 'in', ['Engineer', 'Supplier', 'Support and Engineer', 'Admin and Engineer']).get()
      .then(snap => {
        snap.forEach(doc => {
          this.engineers.push({name: doc.data().Name, key: doc.id})
          this.activeEngineers.push(doc.data().id)
        })
      })
    }
    // fireStore.collection('Customers').get()
    // .then(snap => {
    //   snap.forEach(doc => {
    //     this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName})
    //   })
    //   this.customerList.sort(function (a, b) {
    //     const aName = a.name.toLowerCase()
    //     const bName = b.name.toLowerCase()
    //     return aName < bName ? -1 : aName > bName ? 1 : 0
    //   })
    // })
    // this.periodStart = moment().startOf('month').toDate()
    // this.periodEnd = moment().startOf('month').toDate()
    // this.dateLabel = moment().format('MMMM YYYY')
    this.setShowDate(moment().toDate())
    // this.getEvents()
  },
  computed: {
    customerList () {
      return this.$store.getters.customers
    },
    filteredEvents () {
      let events = []
      this.events.forEach(event => {
        if (this.activeEngineers.indexOf(event.engineer) !== -1) {
          events.push(event)
        }
      })
      return events
    },
    groupedEvents () {
      let eventCounts = {}
      let events = []
      this.events.forEach(event => {
        if (!eventCounts[event.startDate]) {
          eventCounts[event.startDate] = 0
        }
        eventCounts[event.startDate]++
      })
      for (let index in eventCounts) {
        events.push({
          title: eventCounts[index] + ' Jobs',
          startDate: index,
          id: index
        })
      }
      return events
    },
    customers () {
      let obj = {}
      this.customerList.forEach(customer => {
        obj[customer.key] = customer.name
      })
      return obj
    },
    templates () {
      return this.$store.getters.deviceTypes
    }
  },
  watch: {
    displayPeriodUom (val) {
      this.setShowDate(this.showDate)
    },
    dayViewProps: {
      deep: true,
      handler: function (newVal) {
        this.setShowDate(moment(newVal.Day).toDate())
      }
    }
  },
  methods: {
    setShowDate (d) {
      this.showDate = d
      this.periodStart = moment(d).startOf(this.displayPeriodUom)
      this.periodEnd = moment(d).endOf(this.displayPeriodUom)
      if (this.displayPeriodUom === 'month') {
        this.dateLabel = moment(d).format('MMMM YYYY')
      } else if (this.displayPeriodUom === 'week') {
        if (this.periodStart.year() !== this.periodEnd.year()) {
          this.dateLabel = moment(this.periodStart).format('MMMM DD, YYYY') + ' - ' + moment(this.periodEnd).format('MMMM DD, YYYY')
        } else if (this.periodStart.month() !== this.periodEnd.month()) {
          this.dateLabel = moment(this.periodStart).format('MMMM DD') + ' - ' + moment(this.periodEnd).format('MMMM DD, YYYY')
        } else {
          this.dateLabel = moment(this.periodStart).format('MMMM DD') + ' - ' + moment(this.periodEnd).format('DD, YYYY')
        }
      }
      this.getEvents()
    },
    getEvents () {
      this.gettingEvents = true
      this.events = []
      if (this.Supplier) {
        fireStore.collection('Jobs')
        .where('Supplier', '==', this.Supplier)
        .where('Date', '>=', this.periodStart.format('YYYY-MM-DD'))
        .where('Date', '<=', this.periodEnd.format('YYYY-MM-DD'))
        .get()
        .then(docs => {
          docs.forEach(doc => {
            this.events.push({
              vehReg: doc.data().vehReg,
              JobNo: doc.data().JobNo,
              title: doc.data().JobNo,
              startDate: doc.data().Date,
              endDate: doc.data().Date,
              Status: doc.data().Status,
              Supplier: doc.data().Supplier,
              engineer: doc.data().Allocated,
              Customer: doc.data().Customer,
              templates: doc.data().templates,
              id: doc.data().id
            })
          })
          this.gettingEvents = false
        })
      } else {
        fireStore.collection('Jobs')
        .where('Date', '>=', this.periodStart.format('YYYY-MM-DD'))
        .where('Date', '<=', this.periodEnd.format('YYYY-MM-DD'))
        .get()
        .then(docs => {
          docs.forEach(doc => {
            this.events.push({
              vehReg: doc.data().vehReg,
              JobNo: doc.data().JobNo,
              title: doc.data().JobNo,
              startDate: doc.data().Date,
              endDate: doc.data().Date,
              Status: doc.data().Status,
              Supplier: doc.data().Supplier,
              engineer: doc.data().Allocated,
              Customer: doc.data().Customer,
              templates: doc.data().templates,
              id: doc.data().id
            })
          })
          this.gettingEvents = false
        })
      }
    },
    previousYear () {
      this.setShowDate(moment(this.showDate).subtract('1', 'years').toDate())
    },
    previousPeriod () {
      this.setShowDate(moment(this.showDate).subtract('1', this.displayPeriodUom).startOf(this.displayPeriodUom).toDate())
    },
    nextPeriod () {
      this.setShowDate(moment(this.showDate).add('1', this.displayPeriodUom).startOf(this.displayPeriodUom).toDate())
    },
    nextYear () {
      this.setShowDate(moment(this.showDate).add('1', 'years').toDate())
    },
    today () {
      this.setShowDate(moment().toDate())
    },
    selectDate (date) {
      this.showDate = date
      if (this.displayPeriodUom === 'week') {
        this.dayViewProps = {
          Day: date,
          Supplier: this.Supplier,
          viewingDay: true
        }
      } else {
        this.displayPeriodUom = 'week'
      }
    },
    selectEvent (event) {
      this.dayViewProps = {
        Day: event.startDate,
        Supplier: this.Supplier,
        viewingDay: true
      }
    }
  }
}
</script>

<style>
  .period-month .cv-week {
    min-height: 10em!important;
  }

  .period-week .cv-week {
    min-height: 50em!important;
  }

  .cv-wrapper .cv-event {
    height: 2em!important;
  }

  .theme-default .cv-header button.navButton {
    color: #fff!important;
  }

  .theme-default .cv-header button.navButton:disabled {
    color: #ccc!important;
    background-color: inherit!important;
  }

  .cv-header-nav button.navButton {
    padding: 0!important;
  }

  .cv-wrapper .cv-event {
    background-color: #673ab7 !important;
    border-color: #9b7bd5 !important;
    color: #ffffff!important;
    line-height: 2em!important;
    height: 2em!important;
    padding: 0 0.6em!important;
    cursor: pointer!important;
  }

  .cv-header button {
    box-sizing: inherit!important;
    line-height: inherit!important;
    font-size: inherit!important;
    border-width: inherit!important;
  }

  .cv-header,
  .cv-header button {
    border-style: inherit!important;
    border-color: inherit!important;
  }

  .cv-week .cv-day {
    cursor: -webkit-zoom-in!important;
    cursor: zoom-in!important;
  }

  .period-week .cv-day:hover {
    background-color: #f0f0f0!important;
  }

  .period-month .cv-week:hover .cv-day {
    background-color: #f0f0f0!important;
  }
</style>


// WEBPACK FOOTER //
// Calendar.vue?1a7bbfa8